module.exports = __webpack_public_path__ + "media/images/amenities_icons/computer_pc-7dfbaf8a60ddc8d51f5832ab78e4f9c7.svg";